export const LAST_AUTO_OPEN_TIMESTAMP_KEY = 'last-auto-open-timestamp';
